(function () {
  'use strict';

  var settings = window.dwMemberPricing || {};
  var isMembersMode = settings.mode !== 'open_sale';
  var labels = settings.labels || {};

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function getCheckbox(item) {
    return item.querySelector('.spice-spa-addon-checkbox-input');
  }

  function getQuantity(item) {
    var input = item.querySelector('.spice-spa-addon-product-quantity');
    return Math.max(1, Number(input && input.value) || 1);
  }

  function getPrice(item) {
    var price = item.querySelector('.spice-spa-addon-price-main');
    if (!price) return 0;

    var cents = Number(price.getAttribute('variant_price'));
    if (price.hasAttribute('variant_price') && Number.isFinite(cents) && cents >= 0) return cents;

    var numericPrice = Number(price.textContent.replace(/[^0-9.]/g, ''));
    return Number.isFinite(numericPrice) ? Math.round(numericPrice * 100) : 0;
  }

  function getComparePrice(item) {
    var compare = item.querySelector('.spice-spa-addon-price-compare');
    if (!compare) return 0;

    var numericPrice = Number(compare.textContent.replace(/[^0-9.]/g, ''));
    return Number.isFinite(numericPrice) ? Math.round(numericPrice * 100) : 0;
  }

  function hasMemberPrice(item) {
    var compare = getComparePrice(item);
    var price = getPrice(item);
    return compare > price && (compare - price) * 100 >= compare * 2;
  }

  function formatMemberPrice(item) {
    var priceContainer = item.querySelector('.spice-spa-addon-product-price');
    var mainPrice = item.querySelector('.spice-spa-addon-price-main');
    var comparePrice = item.querySelector('.spice-spa-addon-price-compare');
    if (!priceContainer || !mainPrice) return;

    var memberRow = priceContainer.querySelector('.dw-epa-member-row');
    var memberLabel = priceContainer.querySelector('.dw-epa-member-label');
    var saving = priceContainer.querySelector('.dw-epa-member-saving');
    var memberPriced = hasMemberPrice(item);

    priceContainer.classList.toggle('dw-epa-price--member', memberPriced);
    priceContainer.classList.toggle('dw-epa-price--standard', !memberPriced);
    if (comparePrice) comparePrice.hidden = !memberPriced;

    if (!memberPriced) {
      mainPrice.setAttribute('aria-label', 'Price');
      if (memberRow && memberRow.parentNode) {
        priceContainer.insertBefore(mainPrice, memberRow);
        memberRow.remove();
      }
      return;
    }

    if (!memberRow) {
      memberRow = document.createElement('div');
      memberRow.className = 'dw-epa-member-row';
      memberLabel = document.createElement('span');
      memberLabel.className = 'dw-epa-member-label';
      memberLabel.textContent = isMembersMode ? (labels.member || 'MEMBERS') : (labels.sale || 'SALE');
      saving = document.createElement('span');
      saving.className = 'dw-epa-member-saving';
      memberRow.appendChild(memberLabel);
      memberRow.appendChild(mainPrice);
      memberRow.appendChild(saving);
      priceContainer.appendChild(memberRow);
    }

    var discount = Math.round(((getComparePrice(item) - getPrice(item)) * 100) / getComparePrice(item));
    if (saving) saving.textContent = discount + '% OFF';
    if (comparePrice) comparePrice.setAttribute('aria-label', 'Standard price');
    mainPrice.setAttribute('aria-label', settings.hideSaleWording ? (labels.price || 'Price') : isMembersMode ? 'Members price' : 'Sale price');
  }

  function updateItem(item) {
    var checkbox = getCheckbox(item);
    var toggle = item.querySelector('[data-dw-epa-toggle]');
    var quantityInput = item.querySelector('.spice-spa-addon-product-quantity');
    var quantityControl = item.querySelector('.dw-epa-quantity');
    var decrease = item.querySelector('[data-dw-epa-decrease]');
    var selected = !!(checkbox && checkbox.checked);

    item.classList.toggle('is-selected', selected);
    formatMemberPrice(item);

    if (toggle) {
      toggle.classList.toggle('is-selected', selected);
      toggle.setAttribute('aria-pressed', selected ? 'true' : 'false');
      toggle.textContent = selected ? 'Added' : 'Add';
      toggle.disabled = !!(checkbox && checkbox.disabled);
    }

    var image = item.querySelector('.dw-epa-select-image');
    if (image) {
      image.setAttribute('aria-pressed', selected ? 'true' : 'false');
      image.setAttribute('aria-disabled', checkbox && checkbox.disabled ? 'true' : 'false');
    }

    if (quantityControl) quantityControl.hidden = !selected;
    if (decrease) decrease.disabled = !selected || getQuantity(item) <= 1;
    if (quantityInput) quantityInput.setAttribute('aria-label', 'Accessory quantity');
  }

  function updateDisclosure(root, selectedCount) {
    var meta = root.querySelector('[data-dw-epa-disclosure-meta]');
    var action = root.querySelector('[data-dw-epa-disclosure-action]');
    var disclosure = root.querySelector('[data-dw-epa-disclosure]');
    if (!meta) return;

    var availableCount = root.querySelectorAll('.spice-spa-addon-product-item').length;
    var expanded = !root.classList.contains('dw-epa-mobile-collapsed');

    meta.textContent = selectedCount > 0
      ? selectedCount + (selectedCount === 1 ? ' accessory selected' : ' accessories selected')
      : availableCount + (availableCount === 1 ? ' compatible accessory' : ' compatible accessories');

    if (action) {
      action.textContent = expanded
        ? 'Hide accessories'
        : (selectedCount > 0 ? 'Review accessories' : 'Choose accessories');
    }

    if (disclosure) disclosure.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function updateSummary(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('.spice-spa-addon-product-item'));
    var selectedItems = items.filter(function (item) {
      var checkbox = getCheckbox(item);
      return checkbox && checkbox.checked;
    });
    var summary = root.querySelector('[data-dw-epa-summary]');
    if (!summary) return;

    var count = selectedItems.reduce(function (total, item) {
      return total + getQuantity(item);
    }, 0);
    var total = selectedItems.reduce(function (amount, item) {
      return amount + (getPrice(item) * getQuantity(item));
    }, 0);
    var hasSelectedMemberPrice = selectedItems.some(hasMemberPrice);
    var countText = summary.querySelector('[data-dw-epa-count]');
    var totalText = summary.querySelector('[data-dw-epa-total]');
    var priceContext = summary.querySelector('[data-dw-epa-price-context]');

    summary.hidden = selectedItems.length === 0;
    if (countText) countText.textContent = count + (count === 1 ? ' accessory selected' : ' accessories selected');
    if (totalText) totalText.textContent = '+' + formatMoney(total);
    if (priceContext) {
      priceContext.hidden = settings.hideSaleWording || !hasSelectedMemberPrice;
      priceContext.textContent = isMembersMode
        ? (settings.loggedIn ? 'Members Price applied' : 'Sign in to access Members Prices')
        : 'Sale price applied';
    }

    updateDisclosure(root, selectedItems.length);

    items.forEach(updateItem);
  }

  function changeQuantity(item, direction) {
    var input = item.querySelector('.spice-spa-addon-product-quantity');
    if (!input) return;

    var nextValue = Math.max(1, getQuantity(item) + direction);
    input.value = String(nextValue);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function enhanceItem(item, root) {
    if (item.dataset.dwEpaEnhanced === 'true') return;

    var checkbox = getCheckbox(item);
    var form = item.querySelector('.spice-spa-addon-form');
    var image = item.querySelector('.spice-spa-addon-product-image');
    var quantityInput = item.querySelector('.spice-spa-addon-product-quantity');
    if (!checkbox || !form) return;

    item.dataset.dwEpaEnhanced = 'true';

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'dw-epa-toggle';
    toggle.setAttribute('data-dw-epa-toggle', '');
    toggle.addEventListener('click', function () {
      checkbox.click();
      window.setTimeout(function () {
        updateSummary(root);
      }, 0);
    });
    form.insertBefore(toggle, form.firstChild);

    if (image) {
      var itemTitle = item.querySelector('.spice-spa-addon-product-title');
      image.classList.add('dw-epa-select-image');
      image.setAttribute('role', 'button');
      image.setAttribute('tabindex', '0');
      image.setAttribute('aria-label', 'Add ' + (itemTitle ? itemTitle.textContent.trim() : 'accessory'));

      var toggleFromImage = function () {
        checkbox.click();
        window.setTimeout(function () {
          updateSummary(root);
        }, 0);
      };

      image.addEventListener('click', toggleFromImage);
      image.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        toggleFromImage();
      });
    }

    if (quantityInput && !quantityInput.closest('.dw-epa-quantity')) {
      var quantityControl = document.createElement('div');
      quantityControl.className = 'dw-epa-quantity';

      var quantityLabel = document.createElement('span');
      quantityLabel.className = 'dw-epa-quantity__label';
      quantityLabel.textContent = 'Qty';

      var decrease = document.createElement('button');
      decrease.type = 'button';
      decrease.className = 'dw-epa-quantity__button';
      decrease.setAttribute('data-dw-epa-decrease', '');
      decrease.setAttribute('aria-label', 'Decrease accessory quantity');
      decrease.textContent = '-';

      var increase = document.createElement('button');
      increase.type = 'button';
      increase.className = 'dw-epa-quantity__button';
      increase.setAttribute('aria-label', 'Increase accessory quantity');
      increase.textContent = '+';

      quantityInput.parentNode.insertBefore(quantityControl, quantityInput);
      quantityControl.appendChild(quantityLabel);
      quantityControl.appendChild(decrease);
      quantityControl.appendChild(quantityInput);
      quantityControl.appendChild(increase);

      decrease.addEventListener('click', function () {
        changeQuantity(item, -1);
      });
      increase.addEventListener('click', function () {
        changeQuantity(item, 1);
      });
    }

    updateItem(item);
  }

  function enhanceRoot(root) {
    var heading = root.querySelector('.spice-spa-addon-heading');
    var wrapper = root.querySelector('.spice-spa-addon-product-wrapper');
    if (!heading || !wrapper) return false;

    if (!wrapper.id) {
      var firstCheckbox = root.querySelector('.spice-spa-addon-checkbox-input');
      wrapper.id = 'dw-epa-products-' + (firstCheckbox ? firstCheckbox.value : 'accessories');
    }

    if (!root.querySelector('[data-dw-epa-disclosure]')) {
      var disclosure = document.createElement('button');
      disclosure.type = 'button';
      disclosure.className = 'dw-epa-disclosure';
      disclosure.setAttribute('data-dw-epa-disclosure', '');
      disclosure.setAttribute('aria-controls', wrapper.id);
      disclosure.setAttribute('aria-expanded', 'false');

      var disclosureImages = document.createElement('span');
      disclosureImages.className = 'dw-epa-disclosure__images';
      disclosureImages.setAttribute('aria-hidden', 'true');

      Array.prototype.slice.call(
        wrapper.querySelectorAll('.spice-spa-addon-product-image img'),
        0,
        3
      ).forEach(function (image) {
        var preview = document.createElement('img');
        preview.src = image.currentSrc || image.src;
        preview.alt = '';
        preview.width = 44;
        preview.height = 44;
        disclosureImages.appendChild(preview);
      });

      var disclosureCopy = document.createElement('span');
      disclosureCopy.className = 'dw-epa-disclosure__copy';

      var disclosureTitle = document.createElement('span');
      disclosureTitle.className = 'dw-epa-disclosure__title';
      disclosureTitle.textContent = 'Complete your setup';

      var disclosureMeta = document.createElement('span');
      disclosureMeta.className = 'dw-epa-disclosure__meta';
      disclosureMeta.setAttribute('data-dw-epa-disclosure-meta', '');

      var disclosureAction = document.createElement('span');
      disclosureAction.className = 'dw-epa-disclosure__action';

      var disclosureActionLabel = document.createElement('span');
      disclosureActionLabel.setAttribute('data-dw-epa-disclosure-action', '');
      disclosureActionLabel.textContent = 'Choose accessories';

      var disclosureChevron = document.createElement('span');
      disclosureChevron.className = 'dw-epa-disclosure__chevron';
      disclosureChevron.setAttribute('aria-hidden', 'true');

      disclosureCopy.appendChild(disclosureTitle);
      disclosureCopy.appendChild(disclosureMeta);
      disclosureAction.appendChild(disclosureActionLabel);
      disclosureAction.appendChild(disclosureChevron);
      disclosure.appendChild(disclosureImages);
      disclosure.appendChild(disclosureCopy);
      disclosure.appendChild(disclosureAction);
      heading.insertAdjacentElement('afterend', disclosure);
      root.classList.add('dw-epa-mobile-collapsed');

      disclosure.addEventListener('click', function () {
        root.classList.toggle('dw-epa-mobile-collapsed');
        updateDisclosure(
          root,
          root.querySelectorAll('.spice-spa-addon-checkbox-input:checked').length
        );
      });
    }

    if (!root.querySelector('[data-dw-epa-summary]')) {
      var summary = document.createElement('div');
      summary.className = 'dw-epa-summary';
      summary.setAttribute('data-dw-epa-summary', '');
      summary.setAttribute('role', 'status');
      summary.setAttribute('aria-live', 'polite');
      summary.hidden = true;
      summary.innerHTML =
        '<div class="dw-epa-summary__copy">' +
          '<strong data-dw-epa-count></strong>' +
          '<span>Will be added with the main product.</span>' +
        '</div>' +
        '<div class="dw-epa-summary__actions">' +
          '<strong data-dw-epa-total></strong>' +
          '<span data-dw-epa-price-context></span>' +
          '<button type="button" data-dw-epa-clear>Clear</button>' +
        '</div>';
      wrapper.insertAdjacentElement('afterend', summary);

      summary.querySelector('[data-dw-epa-clear]').addEventListener('click', function () {
        root.querySelectorAll('.spice-spa-addon-product-quantity').forEach(function (input) {
          input.value = '1';
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        root.querySelectorAll('.spice-spa-addon-checkbox-input:checked').forEach(function (checkbox) {
          checkbox.click();
        });
        window.setTimeout(function () {
          updateSummary(root);
        }, 0);
      });
    }

    root.querySelectorAll('.spice-spa-addon-product-item').forEach(function (item) {
      enhanceItem(item, root);
    });
    updateSummary(root);

    if (root.dataset.dwEpaObserverReady !== 'true') {
      root.dataset.dwEpaObserverReady = 'true';
      new MutationObserver(function (records) {
        var hasAddonChange = records.some(function (record) {
          if (record.type === 'attributes') return true;

          return Array.prototype.some.call(record.addedNodes, function (node) {
            return node.nodeType === 1 && (
              node.matches('.spice-spa-addon-product-item, .spice-spa-addon-product-wrapper') ||
              node.querySelector('.spice-spa-addon-product-item, .spice-spa-addon-product-wrapper')
            );
          });
        });

        if (hasAddonChange) {
          window.requestAnimationFrame(function () {
            enhanceRoot(root);
          });
        }
      }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['variant_price'] });

      root.addEventListener('change', function () {
        window.setTimeout(function () {
          updateSummary(root);
        }, 0);
      });
      root.addEventListener('input', function () {
        updateSummary(root);
      });
    }

    return true;
  }

  function init() {
    var enhanced = false;

    document.querySelectorAll('#spiceaddonsappid').forEach(function (root) {
      enhanced = enhanceRoot(root) || enhanced;
    });

    return enhanced;
  }

  var discoveryObserver = new MutationObserver(function () {
    if (init()) discoveryObserver.disconnect();
  });

  function start() {
    if (init()) return;

    discoveryObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', init);
}());
